import {
  CHEMKIT_ADDON_FAILED_EVENT,
  CHEMKIT_ADDON_READY_EVENT,
  CHEMKIT_ADDON_WAKE_EVENT,
} from '@chemkit/contracts/integration/addonLifecycle';

export const ADDON_READY_TIMEOUT_MS = 10000;

export const ADDON_WAKE_EVENT = CHEMKIT_ADDON_WAKE_EVENT;

export const ADDON_READY_EVENT = CHEMKIT_ADDON_READY_EVENT;

export const ADDON_FAILED_EVENT = CHEMKIT_ADDON_FAILED_EVENT;
